import React from "react";
import DatePicker, { DateObject } from "react-multi-date-picker";

import moment from "moment";
import { formatDateForDisplay } from "../../utils/HelperFunctions";

const DatePickerInput = ({
  setFieldValue,
  formikName,
  value,
  placeholder,
  disabled,
}) => {
  return (
    <DatePicker
      value={formatDateForDisplay(value, "DD/MM/YYYY", "")}
      format="DD/MM/YYYY"
      onChange={(date) => {
        if (date === null) {
          setFieldValue(formikName, "");
        } else {
          const selectedDate = new Date(date);
          const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
          setFieldValue(formikName, formattedDate);
        }
      }}

      disabled={disabled}
      placeholder={placeholder}
      months={["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]}
    />
  );
};

export default DatePickerInput;
